import { useGSAP } from "@gsap/react";
import { services } from "../constants";
import { animateWithGsap } from "../utils/animations";

const Services = () => {
  useGSAP(() => {
    animateWithGsap("#prestations .section-head", { y: 0, opacity: 1 });
    animateWithGsap(
      "#prestations .service-card",
      { y: 0, opacity: 1, stagger: 0.12 },
      { start: "top 80%" }
    );
  }, []);

  return (
    <section id="prestations" className="section-padding">
      <div className="section-container">
        <div className="section-head reveal">
          <span className="eyebrow">Nos prestations</span>
          <h2 className="section-title">
            Des solutions pour chaque <span className="text-ferrari">besoin</span>
          </h2>
          <p className="section-subtitle">
            Chaque prestation est réalisée sur-mesure et adaptée à votre véhicule.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service) => (
            <article key={service.name} className="service-card card reveal flex flex-col">
              <h3 className="font-display font-semibold text-xl">{service.name}</h3>
              <p className="mt-3 text-chrome-dark text-sm leading-relaxed flex-1">
                {service.description}
              </p>
              <div className="mt-6 flex items-center justify-between">
                <span className="text-ferrari font-semibold">{service.price}</span>
                <a
                  href="#rendez-vous"
                  className="text-sm text-chrome-light hover:text-ferrari transition-colors"
                >
                  Réserver →
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
